import React, { FC } from "react";
import { observer } from "mobx-react";
import { Alert, Grid, Slide, Snackbar as MuiSnackbar, styled, Typography, AlertColor } from "@mui/material";
import { SnackbarOrigin } from "@mui/material/Snackbar/Snackbar";

import { useStores } from "../hooks/useStores.hook";

const anchorOrigin: SnackbarOrigin = {
  vertical: "bottom",
  horizontal: "center",
};

export const Snackbar: FC<{}> = observer(() => {
  const { notificationStore } = useStores();
  const { isToastOpen, toast } = notificationStore;

  const handleClose = () => {
    notificationStore.closeToast();
  };

  if (!toast) {
    return null;
  }

  return (
    <MuiSnackbar
      open={isToastOpen}
      anchorOrigin={anchorOrigin}
      autoHideDuration={2000}
      TransitionComponent={TransitionComponent}
      onClose={handleClose}
    >
      <StyledAlert variant="filled" severity={toast.type.toString() as AlertColor}>
        <Grid container justifyContent="flex-end" justifyItems="center" justifySelf="center">
          <Grid item>
            <Typography>{toast.summary}</Typography>
          </Grid>
        </Grid>
      </StyledAlert>
    </MuiSnackbar>
  );
});

const StyledAlert = styled(Alert)({ whiteSpace: "pre-wrap" });

const TransitionComponent = props => <Slide {...props} direction="up" />;
